/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ProfileSetItemStatus model module.
 * @module model/ProfileSetItemStatus
 * @version 1.0.0
 */
class ProfileSetItemStatus {
    /**
     * Constructs a new <code>ProfileSetItemStatus</code>.
     * @alias module:model/ProfileSetItemStatus
     */
    constructor() { 
        
        ProfileSetItemStatus.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ProfileSetItemStatus</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ProfileSetItemStatus} obj Optional instance to populate.
     * @return {module:model/ProfileSetItemStatus} The populated <code>ProfileSetItemStatus</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ProfileSetItemStatus();

            if (data.hasOwnProperty('app')) {
                obj['app'] = ApiClient.convertToType(data['app'], 'Boolean');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'Boolean');
            }
        }
        return obj;
    }


}

/**
 * @member {Boolean} app
 */
ProfileSetItemStatus.prototype['app'] = undefined;

/**
 * @member {Boolean} email
 */
ProfileSetItemStatus.prototype['email'] = undefined;






export default ProfileSetItemStatus;

